var _path, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPhone(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    transform: "rotate(-.028 0 .006)",
    fill: "url(#phone_svg__pattern0_5426_1775)",
    d: "M0 .006h12.998v12.998H0z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "phone_svg__pattern0_5426_1775",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#phone_svg__image0_5426_1775",
    transform: "scale(.0303)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "phone_svg__image0_5426_1775",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACEAAAAhCAYAAABX5MJvAAAAAXNSR0IArs4c6QAAAERlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAA6ABAAMAAAABAAEAAKACAAQAAAABAAAAIaADAAQAAAABAAAAIQAAAAAWQIAAAAACU0lEQVRYCbWUAXHbQBBFnSIQBJWBGOQY1AwqBjEDuwhiBhGDhIGPQVwESRHUDNr3O7PTPzeSLFnyzvzcv92//1Y6K5vN/9hD38GfAZzIfwd3Cx0wdHiZP9xjCpmWB13b12sO8gWzb2b4A/7Qg6/kfpkuGV+F+lOPGR4ohvY4Jpxb05vwJ2xGDLLVxnQmm05lHk+4G2mrTCe99quE3kQ2p7EnvKD7adqt8UVUQ3yaw6PxPtpZMhlfTGsc4jq0aj8UiUJo85Bobj7ehL/moSupMH+2A87GV6FHXOIJux5HDVD+S296dItSMowh+q7kVNTbRaeNNGdqMUhX6CKvtawV0mXblnY/rDY7vy5pVr8KO+vf5xqDdFao4J8gah9w5e4SW1zjIK21nZLgXnu12uo022H6IjwObHwQ/2Rdt5jrvv2gl8KxK+on9uXVPJFTXj56EO3lOyta1DIIaO/RsYma1t8gAQ1zAl5zLp3qezBpqA6hG5RNZV3aj6LH+/v4M/qrcUYRzXqKuujYWT10sR6o1aAFHbiAqPmayI9GRdWb47V7U8PmDNy4dYHxGr4Frn+z+iBtqPgB4k896gM5mbfgWmwRhGe+Jo66BrmAaNT6AipwSySawivPMdCBZ2uWyTtIYG4kGm4aIg7qzCCMTuQSmBoJYfTmqU2lriURJr5OHSZZf4bfHDWdGfgQwTWMfrwN6ItEMrS5TzA3l2j4BGFarvqsNdQePAIN9gpC18FXi4TTGwjzqav6Vo8axx3I4Nog0m0e9OeOUeHdgARqwxl+BBls/gIrjx9U072CXgAAAABJRU5ErkJggg=="
  }))));
}

export default SvgPhone;